// api/index.js
import axios from 'axios';

//import moment from 'moment'

import parser from '@/helper/base_parser.js'


const instance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URI,
  //baseURL: 'http://127.0.0.1:8000/api/v1/',
  // baseURL: 'https://211.188.69.79:8000/api/v1/',
  // baseURL: 'https://rare.ccrdp.org:8000/api/v1/',
  withCredentials:true,
});


const baseURL =process.env.VUE_APP_BACKEND_URI

export default {

  async getNewHomeData(){
    
    return instance.get("/patient/home_dash/")
  },

  async getOptStatData(){
    //console.log ('getStatData')
    return instance.get("/patient/opt_statview/")
  },
  async getOptStatManagerData(_category){

    try{
      const config = parser.getConfigWithToken();
      //console.log('api. getRequestedPatients with user_email:'+JSON.stringify(user_email))
      
      let requestJSON={
       //email:user_email,
        category: _category
      }

      return instance.post("/patient/opt_statviewmanager/",requestJSON, config)
      
    } catch(err){
      alert ("서버와 통신 중에 문제가 생겼습니다. err:" + JSON.stringify(err));
      console.error(err);
      return err;
    }


    
  },









  
  async getHospitalDisplayList(){
    return instance.get("/hospitalstat/display/")
  },
  
 
  // About user
  async getBaseUrl(){
    console.log(baseURL)
    return baseURL
  },
  
  async getHospitalList(){
    return instance.get("/hospital/")
  },
  async getAreaList(){
    return instance.get("/area/")
  },
  async getOmimList(){
    const config = parser.getConfigWithToken();
    return instance.get("/disease_codes/omim_list/",config)
  },
  async getHpoList(){
    const config = parser.getConfigWithToken();
    return instance.get("/disease_codes/hpo_list/",config)
  }
}







